import Layout from "@/components/Layout";
import { Link } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { CLUB } from "@/lib/club";
import { Megaphone, Sparkles, Heart, Trophy, Construction, ArrowRight } from "lucide-react";

export default function SomosFerro() {
  const { user } = useAuth();
  const firstName = (user?.name || "").split(" ")[0];

  return (
    <Layout>
      <div className="px-6 md:px-10 py-8 max-w-[1500px]" data-testid="somos-ferro-page">
        <div className="mb-8">
          <div className="overline">Comunidad</div>
          <h1 className="font-display text-5xl sm:text-7xl text-white leading-none">
            ¡SOMOS <span className="text-cyan-400">FERRO</span>!
          </h1>
          <p className="text-[#A1A1AA] mt-3 text-sm max-w-2xl">
            El corazón del club. Aquí celebramos lo que somos, lo que hacemos y a dónde vamos juntos.
          </p>
        </div>

        {/* Hero card */}
        <div
          className="relative overflow-hidden border-2 border-cyan-400 p-8 md:p-12 mb-8"
          style={{
            background:
              "radial-gradient(circle at 30% 20%, rgba(34,211,238,0.15) 0%, transparent 50%), linear-gradient(135deg, #0a1628 0%, #050b16 100%)",
          }}
          data-testid="ferro-hero"
        >
          {/* Watermark logo */}
          <img
            src={CLUB.logo}
            alt=""
            className="absolute -right-12 -bottom-12 w-80 h-80 opacity-[0.08] pointer-events-none"
          />
          <div className="relative">
            <div className="flex items-center gap-2 mb-4">
              <Sparkles size={16} className="text-cyan-400" />
              <span className="overline text-cyan-400">Bienvenido{firstName ? `, ${firstName}` : ""}</span>
            </div>
            <div className="font-display text-3xl md:text-4xl text-white leading-tight max-w-2xl">
              UN CLUB. TRES RAMAS.<br />
              <span className="text-cyan-400">UNA SOLA FAMILIA.</span>
            </div>
            <p className="text-[#A1A1AA] mt-4 max-w-xl text-sm leading-relaxed">
              Tackle, Flag Masculino y Flag Femenino — colores distintos, mismo escudo.
              Esta es nuestra casa digital, donde compartimos lo que nos hace Ferro.
            </p>
          </div>
        </div>

        {/* Submodule cards — abren páginas internas dedicadas */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
          <SectionCard to="/somos-ferro/mural"       icon={Megaphone} title="Mural del club"     desc="Anuncios, novedades y mensajes para toda la comunidad."/>
          <SectionCard to="/somos-ferro/logros"      icon={Trophy}    title="Logros & Hitos"     desc="Partidos ganados, jugadores destacados, momentos para recordar."/>
          <SectionCard to="/somos-ferro/tradiciones" icon={Heart}     title="Tradiciones Ferro"  desc="Lo que somos, lo que celebramos, lo que nos une."/>
        </div>

        <div className="tactical-card p-6 mt-6 flex items-center gap-4 flex-wrap" data-testid="coming-soon-notice"
             style={{ borderColor: "#FACC15", background: "linear-gradient(120deg, rgba(250,204,21,0.06) 0%, transparent 60%)" }}>
          <Construction size={28} className="text-[#FACC15] flex-shrink-0"/>
          <div>
            <div className="overline text-[#FACC15]">Módulo en construcción</div>
            <div className="text-sm text-white mt-1">
              Estamos definiendo qué contendrá este espacio. Si tienes ideas, compártelas con la directiva.
            </div>
          </div>
        </div>

        <div className="h-20 md:h-6" />
      </div>
    </Layout>
  );
}

function SectionCard({ to, icon: Icon, title, desc }) {
  const slug = title.toLowerCase().replace(/\s+/g, "-");
  return (
    <Link
      to={to}
      className="tactical-card p-5 hover:border-cyan-400/60 transition-colors group flex flex-col"
      data-testid={`ferro-card-${slug}`}
    >
      <Icon size={22} className="text-cyan-400 mb-3" />
      <div className="font-display text-xl text-white">{title.toUpperCase()}</div>
      <div className="text-xs text-[#A1A1AA] mt-2 leading-relaxed flex-1">{desc}</div>
      <div
        className="text-[10px] uppercase tracking-widest text-cyan-400 mt-4 inline-flex items-center gap-1 group-hover:gap-2 transition-all"
        data-testid={`ferro-card-cta-${slug}`}
      >
        Ver más <ArrowRight size={12} />
      </div>
    </Link>
  );
}
